module.exports={
    "打开Up直播，直播全世界": "أفتح تطبيق Uplive، واستمتع بعروض البث المباشر من جميع أنحاء العالم",
    "录制的小视频来自": "تسجيل الفيديو القصير من",
    "<%=name%>的直播": "<%=name%> مباشر الآن!",
    "其他热门直播": "المزيد من عروض البث المباشر الشائعة",
    "去查看其他精彩直播": "اكتشف المزيد من عروض البث المباشر المذهلة",
    "正在加载": "جارٍ التحميل",
    "<%=num%>在看": "<%=num%> مُشاهد",
    "系统错误": "خطأ فى النظام",
    "获取热门主播失败": "فشل فى الحصول على قائمة الشائع",
    "主播可能在休息，稍后再来试试吧": "الآن هو وقت استراحه المُضيف، الرجاء الانتظار قليلا ثم العوده إليه",
    "没有更多数据了哦": "لا يوجد مزيد من البيانات",
    "哎哟，页面不见了": "الصفحة غير متوافرة حاليًا",
    "哎哟，页面无法查看，请稍候再试": "الصفحة غير متوافرة حاليًا، يُرجى المحاولة بعد قليل",
    "1年前": "قبل سنة مضت",
    "<%=num%>月前": "منذ <%=num%> شهر مضى",
    "<%=num%>天前": "منذ <%=num%> يوم مضى",
    "<%=num%>小时前": "منذ <%=num%> ساعة مضت",
    "<%=num%>分钟前": "منذ <%=num%> دقيقة مضت",
    "刚刚": "الآن",
    "获取用户信息失败, 请稍后重试": "فشل في الحصول على معلومات المستخدم، يُرجى المحاولة بعد قليل",
    "评论": "تعليق",
    "回复": "رد",
    "查看更多评论": "المزيد من التعليقات",
    "图片": "الصور",
    "视频": "فيديو",
    "MM月dd日": "dd يوم MM شهر",
    "AF": "أفغانستان",
    "AL": "ألبانيا",
    "DZ": "الجزائر",
    "AS": "ساموا الأمريكية",
    "AD": "أندورا",
    "AO": "أنغولا",
    "AI": "أنغيلا",
    "AQ": "القطب الجنوبي",
    "AG": "أنتيغوا وبربودا",
    "AR": "الأرجنتين",
    "AM": "أرمينيا",
    "AW": "أروبا",
    "AU": "أستراليا",
    "AT": "النمسا",
    "AZ": "أذربيجان",
    "BS": "الباهاما",
    "BH": "البحرين",
    "BD": "بنغلاديش",
    "BB": "بربادوس",
    "BY": "روسيا البيضاء",
    "BE": "بلجيكا",
    "BZ": "بليز",
    "BJ": "بنين",
    "BM": "برمودا",
    "BT": "بوتان",
    "BO": "بوليفيا",
    "BA": "البوسنة والهرسك",
    "BW": "بوتسوانا",
    "BR": "البرازيل",
    "IO": "إقليم المحيط البريطاني الهندي",
    "VG": "جزر فيرجن البريطانية",
    "BN": "بروناي",
    "BG": "بلغاريا",
    "BF": "بوركينا فاسو",
    "BI": "بوروندي",
    "KH": "كمبوديا",
    "CM": "الكاميرون",
    "CA": "كندا",
    "CV": "الرأس الأخضر",
    "KY": "جزر كايمان",
    "CF": "جمهورية افريقيا الوسطى",
    "TD": "تشاد",
    "CL": "تشيلي",
    "CN": "الصين",
    "CX": "جزيرة عيد الميلاد",
    "CC": "جزر كوكوس",
    "CO": "كولومبيا",
    "KM": "جزر القمر",
    "CK": "جزر كوك",
    "CR": "كوستا ريكا",
    "HR": "كرواتيا",
    "CU": "كوبا",
    "CW": "كوراكاو",
    "CY": "قبرص",
    "CZ": "جمهورية التشيك",
    "CD": "جمهورية الكونغو الديموقراطية",
    "DK": "الدنمارك",
    "DJ": "جيبوتي",
    "DM": "دومينيكا",
    "DO": "جمهورية الدومنيكان",
    "TL": "تيمور الشرقية",
    "EC": "الإكوادور",
    "EG": "مصر",
    "SV": "السلفادور",
    "GQ": "غينيا الإستوائية",
    "ER": "إريتريا",
    "EE": "استونيا",
    "ET": "أثيوبيا",
    "FK": "جزر فوكلاند",
    "FO": "جزر صناعية",
    "FJ": "فيجي",
    "FI": "فنلندا",
    "FR": "فرنسا",
    "PF": "بولينيزيا الفرنسية",
    "GA": "الغابون",
    "GM": "غامبيا",
    "GE": "جورجيا",
    "DE": "ألمانيا",
    "GH": "غانا",
    "GI": "جبل طارق",
    "GR": "اليونان",
    "GL": "الأرض الخضراء",
    "GD": "غرينادا",
    "GU": "غوام",
    "GT": "غواتيمالا",
    "GG": "غيرنسي",
    "GN": "غينيا",
    "GW": "غينيا بيساو",
    "GY": "غيانا",
    "HT": "هايتي",
    "HN": "هندوراس",
    "HK": "هونغ كونغ",
    "HU": "هنغاريا",
    "IS": "أيسلندا",
    "IN": "الهند",
    "ID": "أندونيسيا",
    "IR": "إيران",
    "IQ": "العراق",
    "IE": "أيرلندا",
    "IM": "جزيرة آيل أوف مان",
    "IL": "إسرائيل",
    "IT": "إيطاليا",
    "CI": "ساحل العاج",
    "JM": "جامايكا",
    "JP": "اليابان",
    "JE": "جيرسي",
    "JO": "الأردن",
    "KZ": "كازاخستان",
    "KE": "كينيا",
    "KI": "كيريباس",
    "XK": "كوسوفو",
    "KW": "الكويت",
    "KG": "قرغيزستان",
    "LA": "لاوس",
    "LV": "لاتفيا",
    "LB": "لبنان",
    "LS": "ليسوتو",
    "LR": "ليبيريا",
    "LY": "ليبيا",
    "LI": "ليختنشتاين",
    "LT": "ليتوانيا",
    "LU": "لوكسمبورغ",
    "MO": "ماكاو",
    "MK": "مقدونيا",
    "MG": "مدغشقر",
    "MW": "ملاوي",
    "MY": "ماليزيا",
    "MV": "جزر المالديف",
    "ML": "مالي",
    "MT": "مالطا",
    "MH": "جزر مارشال",
    "MR": "موريتانيا",
    "MU": "موريشيوس",
    "YT": "مايوت",
    "MX": "المكسيك",
    "FM": "ميكرونيزيا",
    "MD": "مولدوفا",
    "MC": "موناكو",
    "MN": "منغوليا",
    "ME": "الجبل الأسود",
    "MS": "مونتسيرات",
    "MA": "المغرب",
    "MZ": "موزمبيق",
    "MM": "ميانمار",
    "NA": "ناميبيا",
    "NR": "ناورو",
    "NP": "نيبال",
    "NL": "هولندا",
    "AN": "جزر الأنتيل الهولندية",
    "NC": "كاليدونيا الجديدة",
    "NZ": "نيوزيلاندا",
    "NI": "نيكاراغوا",
    "NE": "النيجر",
    "NG": "نيجيريا",
    "NU": "نيوي",
    "KP": "كوريا الشمالية",
    "MP": "جزر مريانا الشمالية",
    "NO": "النرويج",
    "OM": "سلطنة عمان",
    "PK": "باكستان",
    "PW": "بالاو",
    "PS": "فلسطين",
    "PA": "بناما",
    "PG": "بابوا غينيا الجديدة",
    "PY": "باراغواي",
    "PE": "بيرو",
    "PH": "الفلبين",
    "PN": "بيتكيرن",
    "PL": "بولندا",
    "PT": "البرتغال",
    "PR": "بورتوريكو",
    "QA": "قطر",
    "CG": "جمهورية الكونغو",
    "RE": "جمع شمل",
    "RO": "رومانيا",
    "RU": "روسيا",
    "RW": "رواندا",
    "BL": "سانت بارتيليمي",
    "SH": "سانت هيلانة",
    "KN": "سانت كيتس ونيفيس",
    "LC": "سانت لوسيا",
    "MF": "سانت مارتن",
    "PM": "سان بيار وميكلون",
    "VC": "سانت فنسنت وجزر غرينادين",
    "WS": "ساموا",
    "SM": "سان مارينو",
    "ST": "ساو تومي وبرينسيبي",
    "SA": "المملكة العربية السعودية",
    "SN": "السنغال",
    "RS": "صربيا",
    "SC": "سيشيل",
    "SL": "سيرا ليون",
    "SG": "سنغافورة",
    "SX": "سانت مارتن",
    "SK": "سلوفاكيا",
    "SI": "سلوفينيا",
    "SB": "جزر سليمان",
    "SO": "الصومال",
    "ZA": "جنوب أفريقيا",
    "KR": "كوريا الجنوبية",
    "SS": "جنوب السودان",
    "ES": "إسبانيا",
    "LK": "سيريلانكا",
    "SD": "سودان",
    "SR": "سورينام",
    "SJ": "سفالبارد وجان مايان",
    "SZ": "سوازيلاند",
    "SE": "السويد",
    "CH": "سويسرا",
    "SY": "سوريا",
    "TW": "تايوان",
    "TJ": "طاجيكستان",
    "TZ": "تنزانيا",
    "TH": "تايلاند",
    "TG": "توغو",
    "TK": "توكيلاو",
    "TO": "تونغا",
    "TT": "ترينداد وتوباغو",
    "TN": "تونس",
    "TR": "تركيا",
    "TM": "تركمانستان",
    "TC": "جزر تركس وكايكوس",
    "TV": "توفالو",
    "VI": "جزر العذراء الأمريكية",
    "UG": "أوغندا",
    "UA": "أوكرانيا",
    "AE": "الإمارات العربية المتحدة",
    "GB": "المملكة المتحدة",
    "US": "الولايات المتحدة",
    "UY": "أوروغواي",
    "UZ": "أوزبكستان",
    "VU": "فانواتو",
    "VA": "الفاتيكان",
    "VE": "فنزويلا",
    "VN": "فيتنام",
    "WF": "واليس وفوتونا",
    "EH": "الصحراء الغربية",
    "YE": "اليمن",
    "ZM": "زامبيا",
    "ZW": "زيمبابوي"
};


// WEBPACK FOOTER //
// ./js/lang/areg.js